import { APP_ROUTES } from "../../../constants/appRoutes";
import { canAccessDepartmentRoute } from "../../Departments/utils/departmentConfig";
import { isConfiguredAdviserCatchUpUser } from "../Tabs/AdviserCatchUp/adviserCatchUpConfig";

export const ADVISER_TAB_DEFINITIONS = [
  { id: "adviserDetails", label: "Adviser Details", permissions: [] },
  {
    id: "clientAgreement",
    label: "Client Agreement",
    permissions: ["Compliance Support", "Compliance", "Administrator", "Adviser Support"],
    strictPermissions: true,
  },
  {
    id: "adviserCatchUp",
    label: "Adviser Catch Up",
    permissions: ["Adviser Support"],
  },
  {
    id: "licenceCertificates",
    label: "Licence Certificates and CPD",
    permissions: ["Licence Certificates", "Licence Certificates Admin"],
    hideForIntroducer: true,
  },
  { id: "ioDetails", label: "IO Details", permissions: [] },
  {
    id: "rates",
    label: "Rates and Bank Details",
    route: APP_ROUTES.IFA_RATES,
    permissions: [],
    hideForIntroducer: true,
  },
  {
    id: "charges",
    label: "Charges",
    permissions: ["Finance Admin", "Administrator", "Tech"],
    strictPermissions: true,
  },
  {
    id: "professionalQualifications",
    label: "Professional Qualifications",
    permissions: [],
  },
  {
    id: "paraplanning",
    label: "Paraplanning",
    permissions: ["Compliance", "Compliance Support", "Finance"],
  },
  { id: "proceding", label: "ProCeding", permissions: ["Finance"] },
  { id: "check2", label: "check²", permissions: ["Administrator"] },
  {
    id: "financialPromotions",
    label: "Financial Promotions",
    permissions: ["Administrator"],
  },
];

const normalisePermissions = (permissions = []) =>
  new Set(
    (Array.isArray(permissions) ? permissions : []).map((permission) =>
      String(permission || "").trim().toLowerCase(),
    ),
  );

export const getVisibleAdviserTabs = (
  permissions = [],
  { isIntroducer = false, userEmail = "" } = {},
) => {
  const available = normalisePermissions(permissions);
  const isAdministrator = available.has("administrator");

  return ADVISER_TAB_DEFINITIONS.filter((tab) => {
    if (tab.hideForIntroducer && isIntroducer) return false;
    if (tab.route) return canAccessDepartmentRoute(permissions, tab.route);
    if (tab.id === "charges" && isConfiguredAdviserCatchUpUser(userEmail)) {
      return true;
    }
    if (tab.permissions.length === 0) return true;
    if (isAdministrator && !tab.strictPermissions) return true;
    return tab.permissions.some((permission) =>
      available.has(permission.toLowerCase()),
    );
  });
};

